import type { User_Legacy } from '@racemap/utilities/types/users';
import type { Immutable } from 'immer';
import { useStore } from '../../store/reducers';

export function useCurrentUser(): Immutable<User_Legacy> | null {
  return useStore((s) => s.users.getter.currentUser());
}
